<div class="config-container shadow my-3">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse()">
    {{ planOrGroup.name }}
    {{ getPlanNames() }}
  </h4>

  <div class="collapse-block" *ngIf="collapseIsVisible">
    <div class="container-fluid">
      <div class="row">
        <div class="col-11">
          <div class="section-form">
            <!-- Hauteur -->
            <div class="form-row">
              <div class="form-label">
                <label>{{ 'workbench.finishes.jamb.height' | translate }}</label>
              </div>
              <div class="form-input">
                <div class="mm">
                  <input
                    type="number"
                    spellcheck="false"
                    step="1"
                    min="1"
                    [value]="getJambsHeight()"
                    (change)="changeJambsHeight($event)" />
                </div>
              </div>
            </div>

            <!-- Polissage -->
            <div class="form-row" *ngIf="jambCanHavePolish()">
              <div class="form-label">
                <label for="jamb-have-polish">{{ 'workbench.finishes.jamb.polish' | translate }}</label>
              </div>
              <div class="form-switch">
                <span class="mr-2">{{ 'generic.no' | translate }}</span>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    id="jamb-have-polish"
                    class="custom-control-input"
                    [checked]="getJambsHavePolish()"
                    (change)="changeJambsHavePolish($event)" />
                  <label class="custom-control-label" for="jamb-have-polish">{{ 'generic.yes' | translate }}</label>
                </div>
              </div>
            </div>

            <!-- Découpe de côté 45°  -->
            <div class="form-row" *ngIf="jambCanHave45DegreesSideCut()">
              <div class="form-label">
                <label for="jamb-have-45-degrees-side-cut">{{
                  'workbench.finishes.jamb.45-degrees-side-cut' | translate
                }}</label>
              </div>
              <div class="form-switch">
                <span class="mr-2">{{ 'generic.no' | translate }}</span>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    id="jamb-have-45-degrees-side-cut"
                    class="custom-control-input"
                    [checked]="getJambsHave45DegreesSideCut()"
                    (change)="changeJambsHave45DegreesSideCut($event)" />
                  <label class="custom-control-label" for="jamb-have-45-degrees-side-cut">{{
                    'generic.yes' | translate
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
